export class ReportMissingData {
  constructor(
    public problem: string,
    public name: string,
    public url: string,
    public notes: string
  ) {}
}
